import React, { Component } from 'react'

import './EventParticipantList.css'

/**
 * Modules
 */
import { Select, Input, List, Avatar, Form, Modal, Button } from 'antd';
import { getStudentsFromEvent, getTeamsFromStudents } from '../../../utils/studentsFunctions';
import EventRegistrationForm from '../eventRegistrationForm/EventRegistrationForm';

import { getAuth, onAuthStateChanged } from 'firebase/auth';

/**
 * Components
 */
// import EventRegistrationForm from '../eventRegistrationForm/EventRegistrationForm';

class EventParticipantList extends Component {

    constructor(props) {
        super(props)

        this.state = {
            eventKey: (this.props.eventId ? this.props.eventId : null),
            arrayOfTeams: [],
            arrayOfStudents: [],
            arrayOfStudentsFiltered: [],

            filterFaixa: '',
            filterPeso: '',
            filterIdade: '',
            filterEquipe: '',

            loading: true,

            studentModal: false,
        }
    }

    componentDidMount = () => {
        this.getAllStudents(this.state.eventKey, true);
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.studentsList && (prevProps.studentsList.length !== this.props.studentsList.length))
            this.getAllStudents(this.props.eventId);
    }

    getAllStudents = async (key) => {
        this.setState({
            arrayOfStudentsFiltered: [],
            loading: true
        })

        /* Get all students */
        let localArray = await getStudentsFromEvent(key);

        // Get all teams
        let teams = await getTeamsFromStudents(localArray);

        this.setState({
            arrayOfStudents: localArray,
            arrayOfStudentsFiltered: localArray,
            arrayOfTeams: teams,
            loading: false
        });
    }

    /**
     * Methods to read student
     */
    searchStudent = (value) => {
        let localFilteredArray = this.state.arrayOfStudents

        /* Create array with the final result and a flag to know when another filter has alread choosed */
        let finalLocalArray = [], hasAnotherFilter = false

        /* Check if a filter of name was determined */
        if (value) {
            if (hasAnotherFilter) {
                let localArrayToReplace = []
                for (let key in finalLocalArray) {
                    if (finalLocalArray[key]['nome'].toLowerCase().includes(value.toLowerCase()))
                        localArrayToReplace.push(finalLocalArray[key])
                }
                finalLocalArray = localArrayToReplace
            } else {
                for (let key in localFilteredArray) {
                    if (localFilteredArray[key]['nome'].toLowerCase().includes(value.toLowerCase()))
                        finalLocalArray.push(localFilteredArray[key])
                }
            }
            hasAnotherFilter = true
        }

        /* Check if a filter of faixa was determined */
        if (this.state.filterFaixa !== '') {
            if (hasAnotherFilter) {
                let localArrayToReplace = []
                for (let key in finalLocalArray) {
                    if (finalLocalArray[key]['faixa'] === this.state.filterFaixa)
                        localArrayToReplace.push(finalLocalArray[key])
                }
                finalLocalArray = localArrayToReplace
            } else {
                for (let key in localFilteredArray) {
                    if (localFilteredArray[key]['faixa'] === this.state.filterFaixa)
                        finalLocalArray.push(localFilteredArray[key])
                }
            }
            hasAnotherFilter = true
        }

        /* Check if a filter of equipe was determined */
        if (this.state.filterEquipe !== '') {
            if (hasAnotherFilter) {
                let localArrayToReplace = []
                for (let key in finalLocalArray) {
                    if (finalLocalArray[key]['equipe'] === this.state.filterEquipe)
                        localArrayToReplace.push(finalLocalArray[key])
                }
                finalLocalArray = localArrayToReplace
            } else {
                for (let key in localFilteredArray) {
                    if (localFilteredArray[key]['equipe'] === this.state.filterEquipe)
                        finalLocalArray.push(localFilteredArray[key])
                }
            }
            hasAnotherFilter = true
        }

        /* Check if hasn't filter was select */
        if (this.state.filterFaixa === '' && this.state.filterEquipe === '' && value === '') {
            finalLocalArray = localFilteredArray
        }

        this.setState({
            arrayOfStudentsFiltered: finalLocalArray,
            loading: false
        })

    }

    filterFaixa = (value) => {
        if (value === null)
            value = ''

        new Promise((resolve, reject) => {
            resolve(
                this.setState({
                    filterFaixa: value
                })
            )
        })
            .then(() => {
                this.searchStudent(this.props.form.getFieldValue('name'))
            })
    }

    filterEquipe = (value) => {
        if (value === null)
            value = ''

        new Promise((resolve, reject) => {
            resolve(
                this.setState({
                    filterEquipe: value
                })
            )
        })
            .then(() => {
                this.searchStudent(this.props.form.getFieldValue('name'))
            })
    }

    /* Methods to open student modal and edit or delete this competitor */
    openStudentModal = async (student) => {
        const auth = await getAuth();
        await onAuthStateChanged(auth, user => {
            if (user) {
                this.setState({
                    studentModal: true,
                    competitorToUpdate: student
                })
            }
        })
    }

    closeCompetitorModal = () => {
        this.setState({ studentModal: false })
        if (this.props.closeUpdateModal)
            this.props.closeUpdateModal()
    }

    render() {

        const { getFieldDecorator } = this.props.form

        return (
            <div>
                <Form>
                    <Form.Item style={{ width: '49%', marginRight: '2%', marginBottom: '5px', float: 'left' }}>
                        {getFieldDecorator('faixa')(
                            <Select
                                showSearch
                                placeholder="Filtrar faixa"
                                optionFilterProp="children"
                                onChange={this.filterFaixa}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                className='sharedInput'
                            >
                                <Select.Option value={null}> </Select.Option>
                                <Select.Option value="whiteSmoke">Branca</Select.Option>
                                <Select.Option value="grey">Cinza</Select.Option>
                                <Select.Option value="yellow">Amarela</Select.Option>
                                <Select.Option value="orange">Laranja</Select.Option>
                                <Select.Option value="green">Verde</Select.Option>
                                <Select.Option value="#ffcc99">Colorido</Select.Option>
                                <Select.Option value="blue">Azul</Select.Option>
                                <Select.Option value="purple">Roxa</Select.Option>
                                <Select.Option value="brown">Marrom</Select.Option>
                                <Select.Option value="black">Preta</Select.Option>
                            </Select>
                        )}
                    </Form.Item>

                    <Form.Item style={{ width: '49%', float: 'left', marginBottom: '5px' }}>
                        {getFieldDecorator('equipe')(
                            <Select
                                showSearch
                                placeholder="Filtrar equipe"
                                optionFilterProp="children"
                                onChange={this.filterEquipe}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                className='sharedInput'
                            >
                                <Select.Option value={null}> </Select.Option>
                                {
                                    this.state.arrayOfTeams.map(team => {
                                        return (
                                            <Select.Option key={team} value={team}>{team}</Select.Option>
                                        )
                                    })
                                }
                            </Select>
                        )}
                    </Form.Item>

                    <Form.Item style={{ width: '100%', marginBottom: '15px', float: 'left' }}>
                        {getFieldDecorator('name')(
                            <Input placeholder="Buscar participante" id='searchInput' onChange={e => this.searchStudent(e.target.value)} className='sharedInput' />
                        )}
                    </Form.Item>
                </Form>
                <div style={{ clear: 'both' }}></div>

                <List
                    locale={{ emptyText: 'Nenhum aluno encontrado' }}
                    className="demo-loadmore-list"
                    itemLayout="horizontal"
                    dataSource={this.state.arrayOfStudentsFiltered}
                    loading={this.state.loading}
                    renderItem={competitor => (
                        <List.Item style={{ cursor: 'pointer' }} onClick={() => this.openStudentModal(competitor)}>
                            <List.Item.Meta
                                style={{ fontSize: 'x-small' }}
                                avatar={<Avatar size='small' style={{ backgroundColor: competitor.faixa }} />}
                                title={competitor.nome}
                                description={competitor.equipe}
                            />
                            <div>
                                {competitor.confirmedPayment === false ? 'Aguardando confirmação de pagamento' : null}
                            </div>
                        </List.Item>
                    )}
                />

                <Modal
                    title='Informações do participante'
                    visible={this.state.studentModal}
                    onCancel={this.closeCompetitorModal}
                    footer={[
                        <Button key='cancel' onClick={this.closeCompetitorModal}>Fechar</Button>
                    ]}
                >
                    <EventRegistrationForm
                        arrayOfTeams={this.state.arrayOfTeams}
                        eventInfo={this.props.event}
                        eventId={this.props.eventId}
                        competitorToUpdate={this.state.competitorToUpdate}
                        closeModal={this.closeCompetitorModal}
                        updateStudentList={() => this.getAllStudents(this.state.eventKey, true)}
                    />
                </Modal>
            </div>
        )
    }

}

export default Form.create()(EventParticipantList)